import { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { OptionType, Select } from '@/components/form/fields/Select/Select';
import { Box } from '@/components/Box/Box';
import BackButtonIcon from '../images/BackArrowIcon.svg?react';
import NextButtonIcon from '../images/NextArrowIcon.svg?react';
import { ButtonWrapper, SelectMonthWrapper, SelectYearWrapper } from './styles';
import { getMonthIndex, getInitialYearOption, getInitialMonthOption, MONTHS_OPTIONS, YEARS_OPTIONS } from '../const';

interface DatePickerHeaderType {
  onYearSelect: (value: number) => void;
  onMonthSelect: (value: number) => void;
  onDecreaseMonth: () => void;
  onIncreaseMonth: () => void;
  date: Date;
}

export const DatePickerHeader = ({
  onYearSelect,
  onMonthSelect,
  onDecreaseMonth,
  onIncreaseMonth,
  date,
}: DatePickerHeaderType) => {
  const [selectedMonth, setSelectedMonth] = useState<OptionType>(() => getInitialMonthOption(date));
  const [selectedYear, setSelectedYear] = useState<OptionType>(() => getInitialYearOption(date));

  const onChangeMount = (option: OptionType) => {
    const monthIndex = getMonthIndex(option.value);

    onMonthSelect(monthIndex);
  };

  const onChangeYear = (option: OptionType) => {
    const selectedYear = Number(option.value);

    onYearSelect(selectedYear);
  };

  useEffect(() => {
    const monthName = format(date, 'LLLL');
    const year = date.getFullYear().toString();

    const selectedMonthOption = MONTHS_OPTIONS.find(({ value }) => value === monthName);
    const selectedYearOption = YEARS_OPTIONS.find(({ value }) => value === year);

    setSelectedMonth(selectedMonthOption);
    setSelectedYear(selectedYearOption);
  }, [date]);

  return (
    <Box flexDirection='row' columnGap='10px'>
      <ButtonWrapper onClick={onDecreaseMonth}>
        <BackButtonIcon />
      </ButtonWrapper>

      <SelectMonthWrapper>
        <Select
          value={selectedMonth}
          options={MONTHS_OPTIONS}
          onChange={onChangeMount}
          variant='compact'
          hasPortal={false}
        />
      </SelectMonthWrapper>

      <SelectYearWrapper>
        <Select
          value={selectedYear}
          options={YEARS_OPTIONS}
          onChange={onChangeYear}
          variant='compact'
          hasPortal={false}
        />
      </SelectYearWrapper>

      <ButtonWrapper onClick={onIncreaseMonth}>
        <NextButtonIcon />
      </ButtonWrapper>
    </Box>
  );
};
